export default __webpack_public_path__ + "static/0-09fa8e81d27e9d735c707c2c3d3d45dd.png";